export default {
  title: "Responsive Lazy Box",
  type: "rh/components/content/responsive-lazy-box",
  config: {
    emptyLabel: "Responsive Lazy Box",
    isEmpty: function (props: any) {
      // Consider the box empty if no children are present
      return !props.children;
    }
  }
};
